import { defineRouter } from '#q-app/wrappers'
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router'
import routes, { ROUTE_NAMES } from './routes'
import useAuthStore from 'stores/auth'
import { storeToRefs } from 'pinia'
import type { RoutePosition } from 'src/router/types'
import isEqual from 'lodash/isEqual'

// кэш позиций маршрутов
const routesSavedPositions: Map<string, RoutePosition> = new Map()

export default defineRouter (function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

  const Router = createRouter({
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      }

      if (to.name && routesSavedPositions.has(String(to.name))) {
        const positionProps = routesSavedPositions.get(String(to.name))
        if (positionProps !== undefined) {
          const { name,  params, query } = to
          // сработает, только если маршруты полностью совпадают в кэше (например при переходе на другие настройки того же
          // маршрута (другой рацион, например), перехода в ту же позицию не произойдет)
          if (isEqual(positionProps.route, { name,  params, query })) {
            return { top: positionProps.position }
          }
        }
      }
      return { top: 0 }
    },
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  })

  Router.beforeEach((to, from) => {
    const authStore = useAuthStore()
    const { isSignedIn, profile } = storeToRefs(authStore)

    if (from && from.name) {
      const { name,  params, query } = from
      routesSavedPositions.set(String(from.name), {
        route: { name,  params, query },
        position: window.scrollY
      })
    }

    // если обязательный вход, редирект на форму входа
    if (to.meta.auth === true && !isSignedIn.value) {
      if (!from || from.name !== ROUTE_NAMES.LOGIN) {
        return { name: ROUTE_NAMES.LOGIN }
      } else if (from && from.name === ROUTE_NAMES.LOGIN) {
        return false
      }
    }

    // если страницы входа, редирект на главную, если авторизация уже есть
    if (to.meta.auth === false && isSignedIn.value) {
      if (!from || from.name !== ROUTE_NAMES.INDEX) {
        return { name: ROUTE_NAMES.INDEX }
      } else if (from && from.name === ROUTE_NAMES.INDEX) {
        return false
      }
    }

    // если страницы платная, то редирект на страницу подписки
    if (to.meta.paid === true && profile.value && !profile.value.is_subscribed && !profile.value.need_onboarding) {
      if (!from || from.name !== ROUTE_NAMES.USER_SUBSCRIPTION) {
        return { name: ROUTE_NAMES.USER_SUBSCRIPTION }
      } else if (from && from.name === ROUTE_NAMES.USER_SUBSCRIPTION) {
        return false
      }
    }
    // если to.meta.auth, значит это полностью публичная страница, доступная всем
  })

  return Router
})
